var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// Time (in minutes) when to write and flush session data to the server
var FLUSH_INTERVAL = 5; // minutes
// Simple batch rotation guard
var MAX_PATHS_PER_BATCH = 50;
// Client debug logging flag
var CLIENT_ANALYTICS_DEBUG = process.env.NEXT_PUBLIC_ANALYTICS_DEBUG === "true";
var getBatchStateKey = function (sessionId, batchSeq) {
    return "analytics_batch_state:".concat(sessionId, ":").concat(batchSeq);
};
// Base64URL-safe decode for JWT payloads (browser-friendly)
var decodeBase64Url = function (input) {
    var base64 = input.replace(/-/g, "+").replace(/_/g, "/") +
        "===".slice((input.length + 3) % 4);
    return atob(base64);
};
// Extract session_id from Supabase JWT without external dependencies
var extractSessionId = function (session) {
    var token = session === null || session === void 0 ? void 0 : session.access_token;
    if (!token)
        return;
    try {
        var payload = token.split(".")[1];
        if (!payload)
            return;
        var json = JSON.parse(decodeBase64Url(payload));
        return json.session_id;
    }
    catch (_a) {
        return undefined;
    }
};
export var createEdgeFunctionTrackSession = function (_a) {
    var supabaseUrl = _a.supabaseUrl, functionName = _a.functionName;
    var baseUrl = supabaseUrl.replace(".supabase.co", ".functions.supabase.co");
    var url = "".concat(baseUrl, "/functions/v1/").concat(functionName);
    return function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var body, nav, blob, queued;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    body = JSON.stringify(data);
                    nav = globalThis.navigator;
                    if (nav && typeof nav.sendBeacon === "function") {
                        blob = new Blob([body], { type: "application/json" });
                        queued = nav.sendBeacon(url, blob);
                        if (queued)
                            return [2 /*return*/];
                        // If the beacon could not be queued, fall through to fetch
                    }
                    if (!(typeof fetch !== "undefined")) return [3 /*break*/, 2];
                    return [4 /*yield*/, fetch(url, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: body,
                        })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
};
export function createAnalytics(_a) {
    var _this = this;
    var _b, _c;
    var supabase = _a.supabase, trackSession = _a.trackSession, pathname = _a.pathname, _d = _a.edgeFunctionName, edgeFunctionName = _d === void 0 ? "analytics-track" : _d, edgeFunction = _a.edgeFunction;
    var sessionRef = null;
    var sessionStartTime = Date.now();
    var batchSeqRef = 0;
    var isDirtyRef = false;
    var resolvedTrackSession = trackSession ||
        createEdgeFunctionTrackSession(edgeFunction
            ? {
                supabaseUrl: edgeFunction.supabaseUrl,
                functionName: (_c = (_b = edgeFunction.functionName) !== null && _b !== void 0 ? _b : edgeFunctionName) !== null && _c !== void 0 ? _c : "analytics-track",
            }
            : {
                supabaseUrl: supabase.supabaseUrl,
                functionName: edgeFunctionName !== null && edgeFunctionName !== void 0 ? edgeFunctionName : "analytics-track",
            });
    var initSession = function () { return __awaiter(_this, void 0, void 0, function () {
        var session, user, supabaseSessionId, analyticsSessionId, batchSeqKey, globalSeqKey, storedSeqRaw, globalSeqRaw, globalSeq, nextSeq, storedSeq, stateKey, restoredState, storedState, globalSeqKey_1, globalSeqRaw, globalSeq;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, supabase.auth.getSession()];
                case 1:
                    session = (_b.sent()).data.session;
                    return [4 /*yield*/, supabase.auth.getUser()];
                case 2:
                    user = (_b.sent()).data.user;
                    supabaseSessionId = extractSessionId(session);
                    analyticsSessionId = supabaseSessionId ||
                        sessionStorage.getItem("anon_session_id") ||
                        "anon-".concat(crypto.randomUUID());
                    // Store anonymous session ID for consistency
                    if (!supabaseSessionId && !sessionStorage.getItem("anon_session_id")) {
                        sessionStorage.setItem("anon_session_id", analyticsSessionId);
                    }
                    batchSeqKey = "analytics_batch_seq:".concat(analyticsSessionId);
                    globalSeqKey = "analytics_global_seq:".concat(analyticsSessionId);
                    storedSeqRaw = sessionStorage.getItem(batchSeqKey);
                    // If no sequence in sessionStorage, this is a new tab/session-instance.
                    // We need to coordinate with other tabs via localStorage to get a unique sequence.
                    if (!storedSeqRaw) {
                        globalSeqRaw = localStorage.getItem(globalSeqKey);
                        globalSeq = globalSeqRaw ? parseInt(globalSeqRaw, 10) || 0 : 0;
                        nextSeq = 0;
                        if (globalSeqRaw !== null) {
                            nextSeq = globalSeq + 1;
                        }
                        localStorage.setItem(globalSeqKey, String(nextSeq));
                        storedSeqRaw = String(nextSeq);
                        sessionStorage.setItem(batchSeqKey, storedSeqRaw);
                    }
                    storedSeq = storedSeqRaw ? parseInt(storedSeqRaw, 10) || 0 : 0;
                    batchSeqRef = storedSeq;
                    stateKey = getBatchStateKey(analyticsSessionId, batchSeqRef);
                    restoredState = null;
                    try {
                        storedState = sessionStorage.getItem(stateKey);
                        if (storedState) {
                            restoredState = JSON.parse(storedState);
                            if (CLIENT_ANALYTICS_DEBUG) {
                                console.log("[analytics] restored batch state", {
                                    sessionId: analyticsSessionId,
                                    batchSeq: batchSeqRef,
                                    paths: ((_a = restoredState === null || restoredState === void 0 ? void 0 : restoredState.pathSequence) === null || _a === void 0 ? void 0 : _a.length) || 0,
                                });
                            }
                        }
                    }
                    catch (_c) { }
                    sessionRef = {
                        sessionId: analyticsSessionId,
                        batchId: (restoredState === null || restoredState === void 0 ? void 0 : restoredState.batchId) || crypto.randomUUID(),
                        batchSeq: batchSeqRef,
                        userId: (user === null || user === void 0 ? void 0 : user.id) || null,
                        metadata: (restoredState === null || restoredState === void 0 ? void 0 : restoredState.metadata) || {},
                        startedAt: new Date(),
                        // Restore arrays if they exist, otherwise start with current page
                        pathSequence: (restoredState === null || restoredState === void 0 ? void 0 : restoredState.pathSequence) || [pathname],
                        pathTimings: (restoredState === null || restoredState === void 0 ? void 0 : restoredState.pathTimings) || [0],
                        interactionSummary: (restoredState === null || restoredState === void 0 ? void 0 : restoredState.interactionSummary) || {},
                        goalEvents: (restoredState === null || restoredState === void 0 ? void 0 : restoredState.goalEvents) || {},
                        featureInteractions: (restoredState === null || restoredState === void 0 ? void 0 : restoredState.featureInteractions) || {},
                        pageLoadTimes: (restoredState === null || restoredState === void 0 ? void 0 : restoredState.pageLoadTimes) || {},
                        errorEvents: (restoredState === null || restoredState === void 0 ? void 0 : restoredState.errorEvents) || [],
                        llmInteractions: (restoredState === null || restoredState === void 0 ? void 0 : restoredState.llmInteractions) || [],
                    };
                    // Consider the initial session state as dirty so that at minimum
                    // the entry page visit can be flushed, which is important for
                    // static page-to-page sites where the user may not trigger
                    // any explicit tracking events before navigating away.
                    isDirtyRef = true;
                    // Ensure a value exists for this session's batch seq in storage
                    if (!storedSeqRaw) {
                        sessionStorage.setItem(batchSeqKey, String(batchSeqRef));
                        globalSeqKey_1 = "analytics_global_seq:".concat(analyticsSessionId);
                        globalSeqRaw = localStorage.getItem(globalSeqKey_1);
                        globalSeq = globalSeqRaw ? parseInt(globalSeqRaw, 10) || 0 : -1;
                        if (batchSeqRef > globalSeq) {
                            localStorage.setItem(globalSeqKey_1, String(batchSeqRef));
                        }
                    }
                    if (CLIENT_ANALYTICS_DEBUG) {
                        // Minimal init log
                        // eslint-disable-next-line no-console
                        console.log("[analytics] init", {
                            sessionId: analyticsSessionId,
                            batchSeq: batchSeqRef,
                            entry: pathname,
                        });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    void initSession();
    // Listen for auth state changes to update session tracking
    var subscription = supabase.auth.onAuthStateChange(function (event, session) {
        var _a;
        if (event === "SIGNED_IN" || event === "TOKEN_REFRESHED") {
            var newSessionId = extractSessionId(session);
            if (newSessionId && sessionRef) {
                sessionRef.sessionId = newSessionId;
                sessionRef.userId = ((_a = session === null || session === void 0 ? void 0 : session.user) === null || _a === void 0 ? void 0 : _a.id) || null;
                sessionStorage.removeItem("anon_session_id");
                // Load persisted batch sequence for the new session id
                // Similar logic to initSession: check session, then global
                var key = "analytics_batch_seq:".concat(newSessionId);
                var globalKey = "analytics_global_seq:".concat(newSessionId);
                var stored = sessionStorage.getItem(key);
                if (!stored) {
                    var globalStored = localStorage.getItem(globalKey);
                    var globalVal = globalStored ? parseInt(globalStored, 10) : -1;
                    var nextVal = globalVal + 1;
                    localStorage.setItem(globalKey, String(nextVal));
                    stored = String(nextVal);
                    sessionStorage.setItem(key, stored);
                }
                var seq = stored ? parseInt(stored, 10) || 0 : 0;
                batchSeqRef = seq;
                sessionRef.batchSeq = seq;
            }
        }
        else if (event === "SIGNED_OUT") {
            var anonSessionId = "anon-".concat(crypto.randomUUID());
            sessionStorage.setItem("anon_session_id", anonSessionId);
            if (sessionRef) {
                sessionRef.sessionId = anonSessionId;
                sessionRef.userId = null;
                // Reset batch seq for a new anon session id
                var key = "analytics_batch_seq:".concat(anonSessionId);
                var globalKey = "analytics_global_seq:".concat(anonSessionId);
                // New anon session, start at 0 (and claim 0 globally)
                batchSeqRef = 0;
                sessionRef.batchSeq = 0;
                sessionStorage.setItem(key, "0");
                localStorage.setItem(globalKey, "0");
            }
        }
    }).data.subscription;
    // Flush session data to server (sends only deltas)
    var flushSessionData = function () { return __awaiter(_this, void 0, void 0, function () {
        var session, stateKey, shouldRotateBySize, lastPath, oldBatchKey, globalKey, globalStored, globalVal, nextSeq, key, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!sessionRef)
                        return [2 /*return*/];
                    session = sessionRef;
                    // Full-state snapshot for this batch (simpler and consistent upserts)
                    if (!isDirtyRef) {
                        if (CLIENT_ANALYTICS_DEBUG) {
                            // eslint-disable-next-line no-console
                            console.log("[analytics] flush:skip (no changes)", {
                                sessionId: session.sessionId,
                                batchSeq: session.batchSeq,
                            });
                        }
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    if (CLIENT_ANALYTICS_DEBUG) {
                        // eslint-disable-next-line no-console
                        console.log("[analytics] flush:start", {
                            sessionId: session.sessionId,
                            batchSeq: session.batchSeq,
                            paths: session.pathSequence.length,
                            interactions: Object.keys(session.interactionSummary).length,
                            goals: Object.keys(session.goalEvents).length,
                        });
                    }
                    // Persist a local snapshot before sending (safety against partial overwrites)
                    try {
                        stateKey = getBatchStateKey(session.sessionId, session.batchSeq);
                        sessionStorage.setItem(stateKey, JSON.stringify({
                            pathSequence: session.pathSequence,
                            pathTimings: session.pathTimings,
                            interactionSummary: session.interactionSummary,
                            goalEvents: session.goalEvents,
                            featureInteractions: session.featureInteractions,
                            pageLoadTimes: session.pageLoadTimes,
                            errorEvents: session.errorEvents,
                            llmInteractions: session.llmInteractions,
                            batchId: session.batchId,
                        }));
                    }
                    catch (_b) { }
                    return [4 /*yield*/, resolvedTrackSession({
                            sessionId: session.sessionId,
                            batchId: session.batchId,
                            batchSeq: session.batchSeq,
                            userId: session.userId,
                            metadata: session.metadata,
                            startedAt: session.startedAt.toISOString(),
                            endedAt: new Date().toISOString(),
                            pathSequence: session.pathSequence,
                            pathTimings: session.pathTimings,
                            entryPoint: session.pathSequence[0],
                            exitPoint: session.pathSequence[session.pathSequence.length - 1],
                            interactionSummary: session.interactionSummary,
                            goalEvents: session.goalEvents,
                            featureInteractions: session.featureInteractions,
                            pageLoadTimes: session.pageLoadTimes,
                            errorEvents: session.errorEvents,
                            llmInteractions: session.llmInteractions,
                            llmTokenUsage: session.llmInteractions.reduce(function (sum, llm) { return sum + llm.tokens; }, 0),
                            llmCostEstimate: session.llmInteractions.reduce(function (sum, llm) { return sum + llm.cost; }, 0),
                            sessionType: determineSessionType(),
                            conversionAchieved: Object.keys(session.goalEvents).length > 0,
                        })];
                case 2:
                    _a.sent();
                    // Clean up old data from memory to prevent unbounded growth
                    if (session.errorEvents.length > 20) {
                        session.errorEvents = session.errorEvents.slice(-20);
                    }
                    if (session.llmInteractions.length > 10) {
                        session.llmInteractions = session.llmInteractions.slice(-10);
                    }
                    shouldRotateBySize = session.pathSequence.length >= MAX_PATHS_PER_BATCH;
                    if (shouldRotateBySize) {
                        if (CLIENT_ANALYTICS_DEBUG) {
                            console.log("[analytics] rotating batch", {
                                sessionId: session.sessionId,
                                oldBatchSeq: session.batchSeq,
                                pathCount: session.pathSequence.length,
                            });
                        }
                        lastPath = session.pathSequence[session.pathSequence.length - 1] || "/";
                        oldBatchKey = getBatchStateKey(session.sessionId, session.batchSeq);
                        try {
                            sessionStorage.setItem(oldBatchKey, JSON.stringify({
                                pathSequence: session.pathSequence,
                                pathTimings: session.pathTimings,
                                interactionSummary: session.interactionSummary,
                                goalEvents: session.goalEvents,
                                featureInteractions: session.featureInteractions,
                                pageLoadTimes: session.pageLoadTimes,
                                errorEvents: session.errorEvents,
                                llmInteractions: session.llmInteractions,
                                batchId: session.batchId,
                                rotated: true, // Mark as rotated
                            }));
                        }
                        catch (_c) { }
                        globalKey = "analytics_global_seq:".concat(session.sessionId);
                        globalStored = localStorage.getItem(globalKey);
                        globalVal = globalStored ? parseInt(globalStored, 10) : batchSeqRef;
                        nextSeq = Math.max(batchSeqRef, globalVal) + 1;
                        localStorage.setItem(globalKey, String(nextSeq));
                        batchSeqRef = nextSeq;
                        key = "analytics_batch_seq:".concat(session.sessionId);
                        sessionStorage.setItem(key, String(batchSeqRef));
                        sessionRef.batchId = crypto.randomUUID();
                        sessionRef.batchSeq = batchSeqRef;
                        sessionRef.startedAt = new Date();
                        // Reset per-batch accumulators for the new batch
                        sessionRef.pathSequence = [lastPath];
                        sessionRef.pathTimings = [0];
                        sessionRef.pageLoadTimes = {};
                        sessionRef.errorEvents = [];
                        sessionRef.llmInteractions = [];
                        // IMPORTANT: keep cumulative maps so we don't lose prior values
                        // sessionRef.interactionSummary stays as-is
                        // sessionRef.goalEvents stays as-is
                        // sessionRef.featureInteractions stays as-is
                    }
                    if (CLIENT_ANALYTICS_DEBUG) {
                        console.log("[analytics] flush:ok", {
                            sessionId: session.sessionId,
                            batchSeq: session.batchSeq,
                        });
                    }
                    isDirtyRef = false;
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error("Failed to track session:", error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    // Determine session type based on behavior
    var determineSessionType = function () {
        if (!sessionRef)
            return "standard";
        var goalEvents = sessionRef.goalEvents, pathSequence = sessionRef.pathSequence, interactionSummary = sessionRef.interactionSummary;
        var totalInteractions = Object.values(interactionSummary).reduce(function (sum, count) { return sum + count; }, 0);
        if (Object.keys(goalEvents).length > 0)
            return "conversion";
        if (pathSequence.length === 1 && totalInteractions < 2)
            return "bounce";
        if (pathSequence.length > 5)
            return "exploration";
        return "standard";
    };
    // Analytics tracking functions
    var trackGoalEvent = function (event) {
        if (!sessionRef)
            return;
        sessionRef.goalEvents[event] = new Date().toISOString();
        isDirtyRef = true;
        // Immediately flush goal events
        flushSessionData();
    };
    var trackInteraction = function (elementType) {
        if (!sessionRef)
            return;
        sessionRef.interactionSummary[elementType] =
            (sessionRef.interactionSummary[elementType] || 0) + 1;
        isDirtyRef = true;
    };
    var trackFeatureUse = function (feature) {
        if (!sessionRef)
            return;
        sessionRef.featureInteractions[feature] =
            (sessionRef.featureInteractions[feature] || 0) + 1;
        isDirtyRef = true;
    };
    var trackPageLoad = function (page, loadTime) {
        if (!sessionRef)
            return;
        sessionRef.pageLoadTimes[page] = loadTime;
        isDirtyRef = true;
    };
    var trackError = function (error) {
        if (!sessionRef)
            return;
        sessionRef.errorEvents.push({
            type: error.type,
            page: pathname,
            time: Date.now() - sessionStartTime,
            message: error.message,
        });
        isDirtyRef = true;
    };
    var trackLLMUsage = function (data) {
        if (!sessionRef)
            return;
        sessionRef.llmInteractions.push({
            model: data.model,
            tokens: data.tokens,
            cost: data.cost,
            timestamp: new Date().toISOString(),
        });
        isDirtyRef = true;
    };
    var trackPageNavigation = function (newPathname) {
        if (!sessionRef)
            return;
        var lastPath = sessionRef.pathSequence[sessionRef.pathSequence.length - 1];
        if (lastPath !== newPathname) {
            var currentTime = Date.now() - sessionStartTime;
            sessionRef.pathSequence.push(newPathname);
            sessionRef.pathTimings.push(currentTime);
            isDirtyRef = true;
            // Batch update session data every 5 page changes
            if (sessionRef.pathSequence.length % 5 === 0) {
                flushSessionData();
            }
            if (CLIENT_ANALYTICS_DEBUG) {
                // eslint-disable-next-line no-console
                console.log("[analytics] nav", {
                    path: newPathname,
                    totalPaths: sessionRef.pathSequence.length,
                });
            }
        }
    };
    // Flush data when page is hidden/unloaded (Blob + beacon)
    var flushOnHide = function () {
        if (!sessionRef)
            return;
        void flushSessionData();
    };
    var handleVisibilityChange = function () {
        if (document.visibilityState === "hidden")
            flushOnHide();
    };
    var flushOnBeforeUnload = function () {
        flushOnHide();
    };
    window.addEventListener("pagehide", flushOnHide);
    window.addEventListener("beforeunload", flushOnBeforeUnload);
    document.addEventListener("visibilitychange", handleVisibilityChange);
    // Periodic flush (every FLUSH_INTERVAL minutes)
    var interval = setInterval(flushSessionData, FLUSH_INTERVAL * 60 * 1000);
    return {
        trackGoalEvent: trackGoalEvent,
        trackInteraction: trackInteraction,
        trackFeatureUse: trackFeatureUse,
        trackPageLoad: trackPageLoad,
        trackError: trackError,
        trackLLMUsage: trackLLMUsage,
        trackPageNavigation: trackPageNavigation,
        cleanup: function () {
            subscription.unsubscribe();
            window.removeEventListener("pagehide", flushOnHide);
            window.removeEventListener("beforeunload", flushOnBeforeUnload);
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            clearInterval(interval);
        },
    };
}
